module.exports = __webpack_public_path__ + "img/time-lady.7a7ded04.svg";